module.exports = "<h1>{{ 'DELETE' | translate }} {{ user.name }}</h1>\n<hr>\n\n<div>\n  <p>{{ 'DELETE_CONFIRM' | translate }}  {{ user.name }}?</p>\n</div>\n\n<div class=\"right\">\n  <button class=\"btn btn-secondary\" (click)=\"dialogRef.close()\">Cancel</button>\n  <button class=\"btn btn-danger\" (click)=\"dialogRef.close(true)\">Delete</button>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/admin/shared/delete-user/delete-user.component.html
// module id = 1418
// module chunks = 0